export function getFormattedYesNoValueForGrid(value: 'true' | boolean | unknown): string {
    const isTrue = value == 'true' || value === true;
    return `SystemSetup.Configuration.Actions.sapConnectionFields.${isTrue ? 'yes' : 'no'}`;
}
